
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/puzzles/[category]",
      function () {
        return require("private-next-pages/puzzles/[category].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/puzzles/[category]"])
      });
    }
  